<div class="px-2 w-full font-bold flex text-1.5 iBTTiny:text-center ism-green lanPixel2xl:text-left">Tutorial: General</div>

<div class="mx-6 px-4 text-white text-1.25 w-full flex flex-col border overlay-dark-30">
  <div class="ism-white">
    <h2 class="ism-green">Welcome to iSkyMarshal</h2>
    <p>A campaign management tool for Starfire, 3rd Edition, revised with SkyMarshal #2.</p>

    <p>A Sky Marshall can create a customized campaign, generate star systems with races and assign them to players (with accounts, of course.)</p>

    <h2 class="ism-green">From the "Campaigns with Races" which is the main page.</h2>

    <p>A player selects a race, their home star system is displayed with the following options on the left-side menu.</p>

    <ul class="ism-white">
      <li>
        <p>[Race] - Allows the player to see race specific information.</p>
        <ul class="ism-white">
          <li>[Star Systems] - Allows players to see all discovered star systems and begins with the race's home star system.</li>
          <li>[Race Properties] - Shows the details of the race. Usually, the player can only change the name of the race. A Sky Marshal has the ability to change other values, including the players that manage the race.</li>
          <li>[Race Encounters] - Lists all encounters for the race.</li>
        </ul>
      </li>
      <li>
        <p>[StartUp Economics] - Is displayed when a race hasn't been completely set up or when the edit turn selector is on the activation turn. Click for more information.</p>
        <ul class="ism-white">
          <li>[Summary]</li>
          <li>[Warships]</li>
          <li>[Defenses]</li>
          <li>[Freighters]</li>
          <li>[Population]</li>
          <li>[Planetary Control Forces]</li>
        </ul>
      </li>
      <li>
        <p>[Economics - Turn] - Is displayed after a race has progressed past the start-up turn or when the edit turn selector is greater than the activation turn. Click for more information.</p>
        <ul class="ism-white">
          <li>[Population Income]</li>
          <li>[Trade Income]</li>
          <li>[Ship Leases]</li>
          <li>[Ship Sales]</li>
          <li>[Other Income]</li>
          <li>[Maintenance]</li>
          <li>[Construction]</li>
          <li>[IU Expansion]</li>
          <li>[Colonization]</li>
          <li>[Troops]</li>
          <li>[Level Research]</li>
          <li>[Tech Projects]</li>
          <li>[Other Expenses]</li>
        </ul>
      </li>
      <li>
        <p>[Messages] -</p>
        <ul class="ism-white">
          <li>[Notifications]</li>
          <li>[Chatroom]</li>
          <li>[Player to Player]</li>
          <li>[Race to Race]</li>
          <li>[Negotiations]</li>
          <li>[Encounters]</li>
        </ul>
      </li>
      <li>
        <p>[Admiralty] - Allows the player to manage the fleets and ships of the race.</p>
        <ul class="ism-white">
          <li>[Fleet Orders] - Allows the player to add, stop, and delete orders. Orders are listed within their fleet.</li>
          <li>[Fleet Administration] - Shows a list of a race's all fleets within all known star systems. Each fleet displays its locations, ships, and orders.</li>
          <li>[Ship Administration] - Shows a list of all built ships with assigned fleets.</li>
          <li>[Class Designs] - Ship classes</li>
          <li>[Shared Designs] - Shared ship classes from other races</li>
          <li>[iShipYard] - "canvas tool" utility to design ship classes</li>
        </ul>
      </li>
      <li>
        <p>[Race Relations] -</p>
        <ul class="ism-white">
          <li>[First Contact Policy]</li>
          <li>[Communication - In Process]</li>
          <li>[Communication - Failed]</li>
          <li>[Sustained Contact]</li>
          <li>[Treaty Negotiations]</li>
        </ul>
      </li>
    </ul>
  </div>
</div>
